'use strict';

/* global $ */
/* global _ */

/**
 *  Обработчик для сворачивания/разворачивания меню
 */

function LeftMenu(options){
    var opt = _.extend({ }, { selector: '.js-groups-main',
                              triggerSelector: '.js-groups-trigger',
                              childsSelector: '.js-groups',
                              itemSelector: '.js-group-item',
                              activeClass: 'is-active',
                              triggerItemClass: 'js-trigger-item',
                              showClass: 'is-shown',
                              triggerWhole: false }, options);

    var items = [];

    var $wrap = $(opt.selector);
    if($wrap.length){
        var $childs = $wrap.children(opt.itemSelector);
        if($childs.length>0){
            var i = 0;
            while(i<$childs.length){
                items.push(new MenuItem($childs.eq(i), null, { childs: opt.childsSelector,
                                                               item: opt.itemSelector,
                                                               trigger: opt.triggerSelector,
                                                               trigger_item_class: opt.triggerItemClass,
                                                               trigger_whole_block: opt.triggerWhole,
                                                               active: opt.activeClass,
                                                               shown: opt.showClass }));
                i++;
            }
        }
    }
}

/**
 * Прототип пункта
 */
var MenuItem = function($dom, parent, options){
    this.$dom = $dom;
    this.$trigger = $();
    this.parent = parent;
    this.childs = [];
    this.is_opened = false;

    this.options = $.extend(true, {}, options);

    this.init();
};

MenuItem.prototype = {
    init: function(){
        var self = this;

        self.active_check();

        self.$trigger = self.$dom.children(self.options.trigger);
        if(self.$trigger.length > 0){
            var $childs_dom = self.$dom.children(self.options.childs);
            if($childs_dom.length>0){
                self.$childs_dom = $childs_dom;
                var $childs = self.$childs_dom.children(self.options.item);
                var i = 0;
                while(i<$childs.length){
                    self.childs.push(new MenuItem($childs.eq(i), self, self.options));
                    i++;
                }
            }

            var $trigger_item = $(document.createElement('span'))
                                    .addClass(self.options.trigger_item_class)
                                    .appendTo(self.$trigger);

            if(self.options.trigger_whole_block){
                self.$trigger.on('click', function(e){
                    e.preventDefault();
                    self.opened_change();
                });
            }else{
                $trigger_item.on('click', function(e){
                    e.preventDefault();
                    self.opened_change();
                });
            }


            self.opened_change(true);
        }
    },
    active_check: function(){
        var self = this;
        if(self.$dom.hasClass(self.options.active)){
            self.is_opened = true;
            if((self.parent) && (!self.parent.is_opened)){
                self.parent.is_opened = true;
            }
        }
    },
    opened_change: function(initial){
        var self = this;
        var opened = self.is_opened;
        if(initial){
            opened = !opened;
        }
        if(opened){
            self.is_opened = false;
            self.$trigger.removeClass(self.options.shown);
            if(initial){
                self.$childs_dom.hide();
            }else{
                self.$childs_dom.stop(true, true).slideUp(400);
            }

        }else{
            self.is_opened = true;
            self.$trigger.addClass(self.options.shown);
            if(initial){
                self.$childs_dom.show();
            }else{
                self.$childs_dom.stop(true, true).slideDown(400);
            }
        }
    },
};


export {
    LeftMenu
};

